/**
 * Ország   * AUSTRIA - Ausztria   * BELGIUM - Belgium   * BOSNIA_AND_HERZEGOVINA - Bosznia hercegovina   * BULGARIA - Bulgária   * OTHER - egyéb…
 */
export type WineCountry =
  | 'AUSTRIA'
  | 'BELGIUM'
  | 'BOSNIA_AND_HERZEGOVINA'
  | 'BULGARIA'
  | 'OTHER';

export const WineCountry = {
  Austria: 'AUSTRIA' as WineCountry,
  Belgium: 'BELGIUM' as WineCountry,
  BosniaAndHerzegovina: 'BOSNIA_AND_HERZEGOVINA' as WineCountry,
  Bulgaria: 'BULGARIA' as WineCountry,
  Other: 'OTHER' as WineCountry,
};
